import { render } from "./linkardInfoItem_Large.vue?vue&type=template&id=9e0a167e&scoped=true&ts=true"
import script from "./linkardInfoItem_Large.vue?vue&type=script&lang=ts"
export * from "./linkardInfoItem_Large.vue?vue&type=script&lang=ts"

import "./linkardInfoItem_Large.vue?vue&type=style&index=0&id=9e0a167e&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e0a167e"]])

export default __exports__